module.exports = __webpack_public_path__ + "img/制御工学4_10.2ef36e4e.png";